import type { CommissionCategory } from '@travel-planner/shared/pricing';
import type { CommissionRateTexts } from './commission-rates';
import { COMMISSION_CATEGORIES } from '@travel-planner/shared/pricing';
import { useId } from 'react';
import { InputGroup } from '../input-group';
import { PercentInput } from '../percent-input';
import { COMMISSION_CATEGORY_LABELS } from './commission-rates';
import css from './commission-rates-fields.module.scss';

type CommissionRatesFieldsProps = {
  value: CommissionRateTexts;
  onChange: (next: CommissionRateTexts) => void;
  /** Shown in an empty field: what applies without a rate of its own. */
  placeholder?: string;
  /** Categories whose text is not a rate from 0 to 100. */
  invalid?: readonly CommissionCategory[];
  disabled?: boolean;
};

/** XT-964 — one commission rate per category; an empty field has none. */
export const CommissionRatesFields = ({
  value,
  onChange,
  placeholder,
  invalid = [],
  disabled,
}: CommissionRatesFieldsProps) => {
  const id = useId();
  return (
    <div className={css.root}>
      {COMMISSION_CATEGORIES.map((category) => (
        <InputGroup
          error={invalid.includes(category) ? 'Enter 0 to 100' : undefined}
          htmlFor={`${id}-${category}`}
          key={category}
          label={`${COMMISSION_CATEGORY_LABELS[category]} commission`}
        >
          <PercentInput
            disabled={disabled}
            id={`${id}-${category}`}
            onChange={(next) => onChange({ ...value, [category]: next })}
            placeholder={placeholder}
            value={value[category]}
          />
        </InputGroup>
      ))}
    </div>
  );
};
